import React from "react";
import PropTypes from "prop-types";
import { Cloud } from "lucide-react";
import logoImage from "../assets/logo/cloudrealtor_logo.png";

const Logo = ({ className = "h-12 w-auto" }) => (
  <button
    type="button"
    onClick={() => (window.location.href = "/")}
    className="flex items-center gap-3 text-white font-bold text-xl select-none focus:outline-none"
    aria-label="CloudRealtor Home"
  >
    <img
      src={logoImage}
      alt="CloudRealtor.io"
      className={`w-auto max-w-full ${className} object-contain`}
      onError={(e) => {
        e.target.style.display = "none";
        e.target.nextSibling.style.display = "flex";
      }}
    />
    <div className="hidden items-center gap-3">
      <Cloud className="h-10 w-10 text-yellow-500" />
      <span className="text-white text-xl font-semibold tracking-tight">CloudRealtor.io</span>
    </div>
  </button>
);

Logo.propTypes = {
  className: PropTypes.string,
};

export default Logo;
